// extracted by mini-css-extract-plugin
export default {"YoutubeEmbed":"ban_a"};